import { AccountApi, AccountRecovery } from '@citruscamps/citrus-client'
import { useState } from 'react'
import { useRequestHandler } from '../../../../../hooks/useRequestHandler'
import translations from '../../../../../translations/en.json'
import { generateApiConfig } from '../../../../../utils/client-config'

interface IRequestRecovery {
  error?: string
  hasSubmitted: boolean
  handleSubmit: (values: AccountRecovery) => Promise<any>
}

export const useRequestRecovery = (): IRequestRecovery => {
  const { requestHandler } = useRequestHandler()
  const [error, setError] = useState<string | undefined>()
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false)

  const handleSubmit = async (values: AccountRecovery): Promise<any> => {
    setHasSubmitted(true)
    try {
      const accountClient = new AccountApi(generateApiConfig())
      await requestHandler(() =>
        accountClient.requestRecoveryEmailAccount({ AccountRecovery: values }),
      )
    } catch (e: any) {
      if (e.status >= 500) {
        const message = e.message || (translations as any)['error.default_toast_message']
        setError(message)
      }
      throw e
    }
  }

  return { hasSubmitted, error, handleSubmit }
}
